<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2">CONTENTS</h2>
<p class="toc1"><a href="#/Text/06_Port01">M<span class="smallcaps">ADAME</span> D<span class="smallcaps">ELPHINE</span></a></p>
<p class="toc1"><span href="#/Text/22_Part02" title="Link target outside of Sample">C<span class="smallcaps">AFÉ DES</span> E<span class="smallcaps">XILÉS</span></span></p>
<p class="toc1"><span href="#/Text/24_Part03" title="Link target outside of Sample">B<span class="smallcaps">ELLES</span> D<span class="smallcaps">EMOISELLES</span> P<span class="smallcaps">LANTATION</span></span></p>
<p class="toc1"><span href="#/Text/26_Part04" title="Link target outside of Sample">“P<span class="smallcaps">OSSON</span> J<span class="smallcaps">ONE</span>’”</span></p>
<p class="toc1"><span href="#/Text/28_Part05" title="Link target outside of Sample">J<span class="smallcaps">EAN-AH</span> P<span class="smallcaps">OQUELIN</span></span></p>
<p class="toc1"><span href="#/Text/30_Part06" title="Link target outside of Sample">’T<span class="smallcaps">ITE</span> P<span class="smallcaps">OULETTE</span></span></p>
<p class="toc1"><span href="#/Text/32_Part07" title="Link target outside of Sample">’S<span class="smallcaps">IEUR</span> G<span class="smallcaps">EORGE</span></span></p>
<p class="toc1"><span href="#/Text/34_Part08" title="Link target outside of Sample">M<span class="smallcaps">ADAME</span> D<span class="smallcaps">ÉLICIEUSE</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_TOC.vue?1e9d5776